import React from 'react';

const DEFAULT_ITEMS = [
  'flutter',
  'react',
  'node',
  'langchain',
  'rag',
  'aws',
  'postgres',
  'typescript',
  'firebase',
  'graphql',
  'docker',
  'openai'
];

/** Endless monospace ticker strip. Decorative, so aria-hidden. */
export default function Marquee({ items = DEFAULT_ITEMS, className = '' }) {
  const loop = [...items, ...items];

  return (
    <div
      aria-hidden="true"
      className={`relative overflow-hidden border-y border-slate-200/80 bg-white/40 py-3
                  dark:border-emerald-500/10 dark:bg-emerald-500/[0.03] ${className}`}
    >
      <div className="mask-fade-x flex w-max animate-marquee gap-8 whitespace-nowrap font-mono text-[11px]
                      uppercase tracking-[0.22em] text-slate-500 dark:text-emerald-500/70">
        {loop.map((item, index) => (
          <span key={`${item}-${index}`} className="inline-flex items-center gap-8">
            <span>{item}</span>
            <span className="text-emerald-500/50">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
